import {
  LargeButton,
  OverlayLoader,
  Ptag
} from "components/core";
import NewRadioCard from "components/core/NewRadioCard";
import routes from "components/routes";
import useUser from "hooks/useUser";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import http from "services/httpService";

function Benefits() {
  const { type } = useParams();
  const { company } = useUser();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);
  const [pickVoluntary, setPickVoluntary] = useState(false);
  const [productList, setProductList] = useState([]);
  const [mandatoryPicked, setMandatoryPicked] = useState(false);
  const [selectedMandatory, setSelectedMandatory] = useState(new Set());
  const [selectedVoluntary, setSelectedVoluntary] = useState(new Set());

  const plan = company?.flex || false;

  const isAddProductFlow = type === "add";

  const getProductList = async () => {
    try {
      const { data } = await http.get("business/product_type_selectables/");
      localStorage.setItem("product_list", JSON.stringify(data));
      filterProductList(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  const filterProductList = (data) => {
    let updatedList = data.map((obj) => ({ ...obj, mandatory: true }));
    if (isAddProductFlow) {
      let alreadySelected = JSON.parse(localStorage.getItem("products")) || {};
      const existing = Object.keys(alreadySelected);
      updatedList = updatedList.filter(
        (prod) => !existing.includes(prod.product_type_name)
      );
    }
    setProductList(updatedList);
  };

  useEffect(() => {
    (async () => {
      setLoader(true);
      await getProductList();
    })();
  }, []);

  const optionHandler = useCallback((value, list, setList, isMandatory) => {
    const newSet = new Set(list);
    if (list.has(value)) {
      newSet.delete(value);
    } else {
      value.mandatory = isMandatory;
      newSet.add(value);
    }
    setList(newSet);
  }, []);

  const selectedVoluntaryOptions = useMemo(() => {
    return productList.filter((product) => !selectedMandatory.has(product));
  }, [productList, selectedMandatory]);

  const postApiCall = async (dataSet) => {
    const postData = Array.from(dataSet);
    setLoader(true);
    try {
      await http.post("business/setup_plan_product/", postData);
      navigate(
        `/${routes.UNIVERSAL_PLAN_SETUP}${isAddProductFlow ? "?path=add" : ""}`
      );
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(false);
    }
  };

  const submitHandler = () => {
    if (!plan) {
      postApiCall(selectedMandatory);
      return;
    }

    if (!mandatoryPicked) {
      setMandatoryPicked(true);
    }

    if (!pickVoluntary) {
      setPickVoluntary(true);
      return;
    }

    const combinedSet = new Set([
      ...Array.from(selectedMandatory),
      ...Array.from(selectedVoluntary)
    ]);
    postApiCall(combinedSet);
  };

  const isButtonDisabled =
    selectedMandatory.size === 0 && selectedVoluntary.size === 0;

  if (loader) return <OverlayLoader />;

  return (
    <section>
      <div style={{ maxWidth: "800px" }} />

      <section style={{ paddingBottom: "5rem" }}>
        {plan && (
          <Ptag fontSize="16px" fontWeight="600" marginTop="20px">
            {pickVoluntary
              ? "Choose Voluntary Products"
              : "Choose Mandatory Products"}
          </Ptag>
        )}

        <div style={{ marginTop: "30px", maxWidth: "800px" }}>
          {!pickVoluntary && (
            <NewRadioCard
              list={productList}
              selected={selectedMandatory}
              onChange={(val) =>
                optionHandler(
                  val,
                  selectedMandatory,
                  setSelectedMandatory,
                  true
                )
              }
            />
          )}

          {pickVoluntary && selectedVoluntaryOptions.length > 0 && (
            <section style={{ marginTop: "2rem" }}>
              <NewRadioCard
                list={selectedVoluntaryOptions}
                selected={selectedVoluntary}
                onChange={(val) =>
                  optionHandler(
                    val,
                    selectedVoluntary,
                    setSelectedVoluntary,
                    false
                  )
                }
              />
            </section>
          )}
        </div>
      </section>

      <footer style={{ maxWidth: "800px", marginTop: "1rem" }}>
        <div style={{ opacity: isButtonDisabled ? 0.6 : 1 }}>
          <LargeButton
            onClick={submitHandler}
            label="Save & Next"
            style={{ padding: "18px 0px" }}
            disabled={isButtonDisabled}
          />
        </div>
      </footer>
    </section>
  );
}

export default Benefits;
